/* ==========================================================================
   Shopify Theme JavaScript
   ========================================================================== */

// Theme object for namespace
window.theme = window.theme || {};

// DOM ready function
theme.domReady = function(callback) {
  if (document.readyState !== 'loading') {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
};

// Mobile menu toggle
theme.mobileMenu = {
  init: function() {
    const menuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');
    
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', this.toggle.bind(this));
    }
  },
  
  toggle: function() {
    const mobileMenu = document.querySelector('.mobile-menu');
    mobileMenu.classList.toggle('is-open');
  }
};

// Cart functionality lives in assets/cart-ajax.js.
//
// A `theme.cart` object used to sit here with addItem()/updateItem() helpers
// that POSTed to /cart/add.js and /cart/update.js. Nothing ever called them --
// the product page did a plain form POST and the drawer used its own fetch. It
// was removed rather than left as a second, divergent add-to-cart path.

// Initialize theme
theme.domReady(function() {
  theme.mobileMenu.init();
  console.log('Shopify theme initialized');
});